import React from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { AllowedRoles } from "@/actions/wp";
import links from "@/constants/links";
import { useAuthSelector, useWpSelector } from "@/selectors";

interface PrivateRouteProps extends RouteProps {
  children: React.ReactNode;
  defaultPath?: string;
}

const UserRoute: React.FC<PrivateRouteProps> = ({
  children,
  defaultPath = links.dashboard,
  ...rest
}) => {
  const { authenticated } = useAuthSelector();
  const { currentUser } = useWpSelector();

  const isAdmin = currentUser?.roles.includes(AllowedRoles.admin);

  return (
    <Route
      {...rest}
      exact
      render={({ location }) =>
        authenticated && !isAdmin ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: defaultPath,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default UserRoute;
